// Tree positions in the resort packages (VIS-268): the reader twin of tools/treepack.py.
// Format 2: x/z are int32 decimetres, 12 bytes per entry. Format 1 (int16) wrapped past ±3,276.7 m; a file in any
// other format throws here instead of being misread (vegetation.json `format`, scene.json treePool `v`).
export const TREE_FORMAT = 2;
const STRIDE = 12;

function view(bytes, n, what, format) {
  if (format !== TREE_FORMAT) throw new Error(`${what}: format ${format ?? 1}, the viewer reads format ${TREE_FORMAT} (rebuild the package)`);
  const buf = bytes instanceof ArrayBuffer ? bytes : bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
  if (buf.byteLength % STRIDE || (n != null && buf.byteLength !== n * STRIDE)) throw new Error(`${what}: ${buf.byteLength} bytes is not ${n ?? 'a whole number of'} entries of ${STRIDE}`);
  return new DataView(buf);
}

/** vegetation/trees.bin (an ArrayBuffer) + its vegetation.json -> per-tree arrays: x, z (m), h (m), r (crown radius, m), s (species), f (flags). */
export function decodeTrees(bytes, meta) {
  const dv = view(bytes, meta?.count, 'trees.bin', meta?.format), n = dv.byteLength / STRIDE;
  const x = new Float32Array(n), z = new Float32Array(n), h = new Float32Array(n), r = new Float32Array(n), s = new Uint8Array(n), f = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    const o = i * STRIDE;
    x[i] = dv.getInt32(o, true) / 10; z[i] = dv.getInt32(o + 4, true) / 10;
    h[i] = dv.getUint8(o + 8) / 10; r[i] = dv.getUint8(o + 9) / 40; s[i] = dv.getUint8(o + 10); f[i] = dv.getUint8(o + 11);
  }
  return { n, x, z, h, r, s, f };
}

/** scene.json treePool ({n, v, data} with data already decoded to bytes): calls fn(x, z, size, kind, coin, baked) per sample, in order. */
export function forEachPoolSample(pool, bytes, fn) {
  const dv = view(bytes, pool.n, 'scene.json treePool', pool.v);
  for (let k = 0; k < pool.n; k++) {
    const o = k * STRIDE;
    fn(dv.getInt32(o, true) / 10, dv.getInt32(o + 4, true) / 10, dv.getUint8(o + 8) / 100, dv.getUint8(o + 9), dv.getUint8(o + 10) / 256, dv.getUint8(o + 11));
  }
}
